import React, { useState } from "react";
import ProjectListing from "../../molecules/ProjectListing";
import SearchBar from "../../atoms/SearchButton";
import UserListing from "../../molecules/UserListing";
import FilterDialogBox from "../../molecules/FilterDialogBox";
import Button from "../../atoms/Button";
import BidNotificationDialog from "../../molecules/HomePageDialogs/BidNotificationDialog";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import KycDialogBox from "../../molecules/HomePageDialogs/KycDialogBox";
import InquireNotificationDialog from "../../molecules/HomePageDialogs/InquireNotificationDialog";
import InquireConfirmation from "../../molecules/HomePageDialogs/InquireConfirmation";
import { ReactComponent as Filter } from "../../svgs/Filterr.svg";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { inquireRequest } from "../../../utils/API/inquireRequest";
import { getkyc } from "../../../utils/API/kyc";

const ProjectUserListing = () => {
  const [showProject, setShowProject] = useState(true);
  const [isFilterDialogOpen, setFilterDialogOpen] = useState(false);
  const [notificationDialogState, setNotificationDialogState] = useState(false);
  const [inquireNotificationState, setInquireNotificationState] =
    useState(false);
  const [inquireConfirmState, setInquireConfirmState] = useState(false);
  const [kycDialogState, setKycDialogState] = useState(false);
  const { userType, kycVerified } = useSelector((state) => state.authReducer);
  const [searchItem, setSearchItem] = useState("");
  const [selectedRegistry, setSelectedRegistry] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProjectVintage, setSelectedProjectVintage] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);
  const [selectedCreditType, setSelectedCreditType] = useState(null);
  const [selectedTypeOfTransaction, setSelectedTypeOfTransaction] =
    useState(null);
  const [lowPrice, setLowPrice] = useState("0");
  const [highPrice, setHighPrice] = useState("50");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const bidHandler = async (url) => {
    if (!userType) {
      setNotificationDialogState(true);
    } else if (userType === "seller") {
      setNotificationDialogState(true);
    } else if (!kycVerified) {
      try {
        const response = await getkyc(dispatch);
        if (response?.data?.kyc_status === "Completed") {
          navigate(url);
        } else {
          setKycDialogState(true);
        }
      } catch (error) {
        console.error("Failed to fetch KYC details:", error);
        toast.error("Failed to verify KYC status. Please try again.");
        setKycDialogState(true);
      }
    } else {
      navigate(url);
    }
  };

  const inquireHandler = async (formData) => {
    if (userType === null) {
      setInquireNotificationState(true);
    } else if (userType === "seller") {
      setInquireNotificationState(true);
    } else if (!kycVerified) {
      setKycDialogState(true);
    } else {
      try {
        await inquireRequest({ formData }, dispatch);
        setInquireConfirmState(true);
      } catch (error) {
        toast.error("Inquiry failed: " + error.message);
      }
    }
  };

  const handleSearch = () => {
    // console.log(searchItem);
  };

  const handleRegistryCheck = (e) => {
    {
      const selectedValue = e.target.value;
      setSelectedRegistry(selectedValue);
    }
  };

  const handleTypeCheck = (e) => {
    const selectedValue = e.target.value;
    setSelectedType(selectedValue);
  };

  const handleUserTypeCheck = (e) => {
    const selectedValue = e.target.value;
    setSelectedUserType(selectedValue);
  };

  const handleTokenCheck = (e) => {
    const selectedToken = e.target.value;
    setSelectedToken(selectedToken);
  };

  const handleCreditType = (e) => {
    const selectedCreditType = e.target.value;
    setSelectedCreditType(selectedCreditType);
  };

  const handleTypeOfTransaction = (e) => {
    const selectedTypeOfTransaction = e.target.value;
    setSelectedTypeOfTransaction(selectedTypeOfTransaction);
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setSelectedCategory(selectedCategory);
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    setSelectedCountry(selectedCountry);
  };

  const handleProjectVintageChange = (e) => {
    const selectedProjectVintage = e.target.value;
    setSelectedProjectVintage(selectedProjectVintage);
  };

  const handleFilterDialogClose = () => {
    setSelectedRegistry(null);
    setSelectedCategory(null);
    setSelectedProjectVintage(null);
    setSelectedToken(null);
    setSelectedCreditType(null);
    setSelectedCountry(null);
    setFilterData(null);
    setSelectedTypeOfTransaction(null);
    setFilterDialogOpen(false);
    setSelectedType(null);
    setSelectedUserType(null);
    setLowPrice("0");
    setHighPrice("50");
  };

  const handleFilterDialogSubmit = () => {
    setFilterDialogOpen(false);
    if (showProject) {
      setFilterData({
        registries: selectedRegistry ? [selectedRegistry] : null,
        categoryId: selectedCategory,
        // ProjectVintageId: selectedProjectVintage,
        country: selectedCountry,
        tokenTypes: selectedToken ? [selectedToken] : null,
        creditType: selectedCreditType,
        typeOfTransaction: selectedTypeOfTransaction,
        priceLow: lowPrice,
        priceHigh: highPrice
      });
    } else {
      setFilterData({
        type: selectedType ? selectedType : null,
        user_type: selectedUserType ? selectedUserType : null
      });
    }
  };

  return (
    <div className="flex flex-col pl-7 w-[75%]">
      <div className="w-full flex header mb-3 justify-between">
        {userType === "trader" ? (
          <h3 className="font-bold text-2xl pl-4">Carbon Credits</h3>
        ) : userType === null ? (
          <h3 className="font-bold text-2xl pl-4">
            Carbon Credits <span className="font-light">available</span>{" "}
          </h3>
        ) : (
          <div className="flex">
            <div
              className={`w-[126px] h-10 rounded-l-lg cursor-pointer flex border-2 items-center justify-center ${
                showProject
                  ? "text-blue-800 font-bold border-blue-800 border-r-2 bg-blue-200"
                  : "text-gray-400 border-r-0"
              }`}
              onClick={() => setShowProject(true)}
            >
              Carbon credit
            </div>
            <div
              className={`w-[126px] h-10 rounded-r-lg flex items-center border-2 justify-center cursor-pointer ${
                !showProject
                  ? "text-blue-800 font-bold border-l-2 border-blue-800 bg-blue-200"
                  : "border-gray-400 border-l-0 "
              }`}
              onClick={() => setShowProject(false)}
            >
              Users
            </div>
          </div>
        )}
        <div className="mr-5 ml-6 w-1/3">
          <SearchBar
            onSearch={handleSearch}
            searchItem={searchItem}
            setSearchItem={setSearchItem}
            variant="secondaryxl"
            className="text-black"
            borderColor="border-none"
            placeholderColor="blue-800"
            inputBackground="blue"
            svgStrokeColor="blue"
            inputWidth="full"
            inputHeight="8"
          />
        </div>
        <div className="">
          <Button
            varient="secondaryxl"
            borderColor="black"
            onClick={() => setFilterDialogOpen(true)}
            className="w-full focus-visible:outline-0 text-sm justify-center pl-4 pr-3 py-[0.5rem]  text-blue-800  bg-blue-200 sm:w-auto flex items-center"
          >
            Filter{" "}
            <span className="pl-8">
              <Filter />
            </span>
          </Button>
        </div>
      </div>
      <div className="w-full">
        {showProject ? (
          <ProjectListing
            onBid={bidHandler}
            onInquire={inquireHandler}
            filterData={filterData}
            type={selectedType}
            searchItem={searchItem}
          />
        ) : (
          <UserListing
            searchItem={searchItem}
            filterData={filterData}
            user_type={selectedUserType}
            type={selectedType}
          />
        )}
        <div className="flex pb-4 gap-x-2">
          <div className=" flex-grow"></div>
          {/* <Button
            onClick={() => {
              navigate(`${showProject ? "/all-carbon-credit" : "/all-users"}`);
            }}
            varient="primary"
            borderColor="blue"
            className="px-10 font-bold py-2 text-sm text-white bg-blue-800"
          >
            See All
          </Button> */}
        </div>
      </div>

      {isFilterDialogOpen && (
        <FilterDialogBox
          open={isFilterDialogOpen}
          onCancel={handleFilterDialogClose}
          onOk={handleFilterDialogSubmit}
          selectedRegistry={selectedRegistry}
          onCheckRegistry={handleRegistryCheck}
          selectedCategory={selectedCategory}
          onSelectCategory={handleCategoryChange}
          selectedProjectVintage={selectedProjectVintage}
          onSelectProjectVintage={handleProjectVintageChange}
          selectedToken={selectedToken}
          onChangeToken={handleTokenCheck}
          selectedCreditType={selectedCreditType}
          onSelectCreditType={handleCreditType}
          selectedCountry={selectedCountry}
          onSelectCountry={handleCountryChange}
          selectedTypeOfTransaction={selectedTypeOfTransaction}
          onSelectTypeOfTransaction={handleTypeOfTransaction}
          min={lowPrice} // Pass lowPrice to the dialog
          max={highPrice} // Pass highPrice to the dialog
          setLowPrice={setLowPrice} // Function to update lowPrice
          setHighPrice={setHighPrice}
          showProject={showProject}
          onCheckType={handleTypeCheck}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
          selectedUserType={selectedUserType}
          onCheckUserType={handleUserTypeCheck}
        />
      )}
      <BidNotificationDialog
        open={notificationDialogState}
        isLoggedIn={userType !== null}
        onCancel={() => setNotificationDialogState(false)}
      />
      <InquireNotificationDialog
        open={inquireNotificationState}
        isLoggedIn={userType !== null}
        onCancel={() => setInquireNotificationState(false)}
      />
      <InquireConfirmation
        open={inquireConfirmState}
        onCancel={() => setInquireConfirmState(false)}
      />
      <KycDialogBox
        open={kycDialogState}
        onCancel={() => setKycDialogState(false)}
      />
    </div>
  );
};

export default ProjectUserListing;
